"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
var react_1 = __importDefault(require("react"));
var prop_types_1 = __importDefault(require("prop-types"));
var core_1 = require("@material-ui/core");
var styled_components_1 = require("styled-components");
var Select_styled_1 = require("./Select.styled");
var atoms_icon_1 = __importDefault(require("@lettucegrow/atoms.icon"));
var atoms_utils_theme_1 = require("@lettucegrow/atoms.utils.theme");
/**
 * * Custom Select field - Material UI select does not allow autocomplete, and autocomplete does not allow native mobile options dropdown
 */
var Select = function Select(_ref) {
  var id = _ref.id,
    className = _ref.className,
    name = _ref.name,
    value = _ref.value,
    required = _ref.required,
    onChange = _ref.onChange,
    label = _ref.label,
    error = _ref.error,
    options = _ref.options,
    modifiers = _ref.modifiers,
    helperText = _ref.helperText,
    autoComplete = _ref.autoComplete,
    onBlur = _ref.onBlur,
    dataAttributes = _ref.dataAttributes,
    disabled = _ref.disabled;
  return react_1.default.createElement(styled_components_1.ThemeProvider, {
    theme: atoms_utils_theme_1.theme
  }, react_1.default.createElement(Select_styled_1.SelectStyled, {
    className: className,
    hasValue: !!value,
    hasError: !!error,
    modifiers: modifiers
  }, react_1.default.createElement(atoms_icon_1.default, null, react_1.default.createElement("svg", {
    xmlns: 'http://www.w3.org/2000/svg',
    width: '7',
    height: '4',
    viewBox: '0 0 7 4'
  }, react_1.default.createElement("path", {
    d: 'M6.643.133c.083-.083.218-.083.3 0 .084.083.084.217.001.3L3.69 3.692c-.083.083-.218.083-.3 0L.132.434C.05.35.05.216.133.133c.083-.083.218-.083.3 0L3.54 3.241 6.643.133z'
  }))), react_1.default.createElement("select", Object.assign({
    id: id,
    name: name,
    value: value,
    onChange: onChange,
    onBlur: onBlur,
    required: required,
    autoComplete: autoComplete,
    disabled: disabled
  }, dataAttributes), react_1.default.createElement("option", {
    key: 'default',
    value: '',
    hidden: true,
    disabled: true,
    selected: true
  }), options.map(function (option, index) {
    return react_1.default.createElement("option", {
      key: index,
      value: option.value
    }, option.label);
  })), react_1.default.createElement("label", null, required ? label + '*' : label), (helperText || error) && react_1.default.createElement(core_1.FormHelperText, {
    error: !!error,
    required: required
  }, error || helperText)));
};
Select.propTypes = {
  id: prop_types_1.default.number,
  className: prop_types_1.default.string,
  name: prop_types_1.default.string,
  value: prop_types_1.default.string,
  required: prop_types_1.default.bool,
  onChange: prop_types_1.default.func,
  onBlur: prop_types_1.default.func,
  label: prop_types_1.default.string,
  error: prop_types_1.default.string,
  options: prop_types_1.default.array,
  autoComplete: prop_types_1.default.string,
  helperText: prop_types_1.default.string,
  dataAttributes: prop_types_1.default.object,
  modifiers: prop_types_1.default.oneOfType([prop_types_1.default.string, prop_types_1.default.array]),
  disabled: prop_types_1.default.bool
};
exports.default = Select;